import { Component, ElementRef, OnInit } from '@angular/core';

import { AdminTitle } from '../../layout/AdminTitle';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { BaseCatalog } from '../BaseCatalog';
import { ITorkCatalog } from '../../model/product/tork/ITorkCatalog';
import { LiveStageService } from '../../environment/LiveStage.service';
import { ObjectIdCrud } from '../../crud/ObjectIdCrud';
import { PrettySubmitGuard } from 'tridion.web.ui/src/app/angular/save/PrettySubmitGuard';
import sortCatalogs from '../sortCatalogs';
import { TorkCatalogApi } from '../../api/product/tork/TorkCatalogApi';

@Component({
    templateUrl: '../BaseCatalog.component.html',
    providers: [TorkCatalogApi]
})
export class TorkCatalogComponent extends BaseCatalog<ITorkCatalog> implements OnInit {
    constructor(
        private adminTitle: AdminTitle,
        private authService: AuthService,
        elementRef: ElementRef,
        liveStageService: LiveStageService,
        prettySubmitGuard: PrettySubmitGuard,
        private torkCatalogApi: TorkCatalogApi
    ) {
        super(elementRef, liveStageService, prettySubmitGuard, 'Tork');
    }

    ngOnInit() {
        this.adminTitle.setTitle('Catalogs - Tork');

        this.filter.observable.subscribe(() => {
            this.torkCatalogApi.getAll().subscribe(catalogs => {
                this.init(sortCatalogs(catalogs));
            });
        });
    }

    protected createCrud() {
        return new ObjectIdCrud(this.torkCatalogApi, this.authService);
    }
}
